<div class="popup_container">
  <div class="popup_header">
    <div class="popup_header-title">
      Choisir un modèle
    </div>
    <div class="popup_header-close" (click)="cancel()">
      <i class="icon icon-x"></i>
    </div>
  </div>
  <ul class="popup_tab">
    <li (click)="switchToMail()" [ngClass]="{'is-active': isTypeMail}">
      Mail
    </li>
    <li (click)="switchToCourrier()" [ngClass]="{'is-active': !isTypeMail}">
      Courrier
    </li>
  </ul>
  <div class="popup_tab-content">
    <div class="popup_tab-themes">
      @for (themeModele of themesAffiches; track themeModele) {
        <div>
          <div class="popup_tab-themes-name" [ngClass]="{'is-active':selectedTheme==themeModele}" (click)="selectTheme(themeModele)">{{getLibelleTheme(themeModele)}}</div>
        </div>
      }
    </div>
    <div class="popup_tab-modeles" content>
      @for (modele of modeles; track modele) {
        <div>
          <div class="popup_tab-modeles-name" [ngClass]="{'is-active':selectedModele!=null && selectedModele.id==modele.id}" (click)="selectionnerModele(modele)">{{modele.nom}}</div>
        </div>
      }
    </div>
  </div>

  <div class="popup_button">
    <button [disabled]="isNothingSelected()"
      (click)="publiposter()" class="button-main">
      <i class="icon icon-send"></i>
      <span class="button-main_text">
        {{getLibelleAction(type)}}
      </span>
    </button>
  </div>
</div>
<div class="popup_background" (click)="cancel()"></div>
